import {cn} from '@/lib/utils'
import {Card, CardContent, CardHeader, CardTitle} from '@/components/ui/card'

export function NumberCard({
  className,
  title,
  value,
  ...props
}: React.ComponentProps<'div'> & {title: string; value: number; textSize?: string | number}) {
  return (
    <Card className={className} {...props}>
      <CardHeader>
        <CardTitle className='text-base'>{title}</CardTitle>
      </CardHeader>
      <CardContent className={cn('h-full flex place-content-center place-items-center align-center', className)}>{value}</CardContent>
    </Card>
  )
}
